import React, { FC } from 'react'
import Heading from 'components/Common/Heading'
import GetHelpCard from 'components/Owner/Tools/GetHelpCard'
import {
  ToolGetHelpWrapper,
  ToolGetHelpHeadingWrapper,
  ToolGetHelpTextWrapper,
  ToolGetHelpText,
} from 'components/Owner/Tools/ToolFlyout/style'

interface IToolGetHelpProps {
  toolHelpText?: string
}
const ToolGetHelp: FC<IToolGetHelpProps> = ({ toolHelpText }) => {
  return (
    <ToolGetHelpWrapper>
      <ToolGetHelpHeadingWrapper>
        <Heading variant="primary" className="!font-[650] !text-2xl leading-7">
          Get additional support
        </Heading>
        <ToolGetHelpTextWrapper>
          <ToolGetHelpText className="text-xl	font-medium py-5">{toolHelpText}</ToolGetHelpText>
        </ToolGetHelpTextWrapper>
        <GetHelpCard />
      </ToolGetHelpHeadingWrapper>
    </ToolGetHelpWrapper>
  )
}

export default ToolGetHelp
